import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'

import { Evaluations } from '~/features/evaluation'
import { ContactLogProvider } from '~/modules/contact-log'
import { useTRPC } from '~/services/trpc'

import { InteractionOverview } from './-components/interaction-overview'
import ShowContactLog from './-components/ShowContactLog'
import { Transcript } from './-components/transcript'

const searchParamsSchema = z.object({
  t: z.number().optional(),
})

export const Route = createFileRoute(
  '/_authenticated/$alias/_app/interaction/$contactLogId/',
)({
  validateSearch: searchParamsSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  const trpc = useTRPC()
  const { data: interaction } = useQuery(
    trpc.interactions.getById.queryOptions(params.contactLogId),
  )
  return (
    <div className="flex">
      <div className="flex-1">
        <InteractionOverview contactLogId={params.contactLogId} />
        <Transcript contactLogId={params.contactLogId} />
      </div>
      <div className="flex-1">
        {!!interaction && (
          <Evaluations
            contactLogId={params.contactLogId}
            userId={interaction?.handledBy}
          />
        )}
      </div>
    </div>
  )
}
